import { render, staticRenderFns } from "./carbonAssignments.vue?vue&type=template&id=5a95b8e1&scoped=true"
import script from "./carbonAssignments.vue?vue&type=script&lang=js"
export * from "./carbonAssignments.vue?vue&type=script&lang=js"
import style0 from "./carbonAssignments.vue?vue&type=style&index=0&id=5a95b8e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a95b8e1",
  null
  
)

export default component.exports